export default __webpack_public_path__ + "static/media/Screenshot_3-1736524931070.87a1bb9c.png";